import { useEffect } from "react";

export const SITE_BASE = "https://www.marizemataxservicellc.com";
const OG_IMAGE = `${SITE_BASE}/icons/logo-512.png`;

function upsertMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export const LOCAL_BUSINESS_LD = {
  "@context": "https://schema.org",
  "@type": "AccountingService",
  "@id": `${SITE_BASE}/#business`,
  "name": "Marizema Tax Service LLC",
  "url": `${SITE_BASE}/`,
  "logo": OG_IMAGE,
  "image": OG_IMAGE,
  "email": "marizematax@gmail.com",
  "telephone": "+18137280702",
  "description": "Professional tax preparation, bookkeeping and financial services for individuals and small businesses in Tampa, Florida.",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Tampa",
    "addressRegion": "FL",
    "addressCountry": "US"
  },
  "areaServed": [
    { "@type": "City", "name": "Tampa, FL" }
  ],
  "contactPoint": {
    "@type": "ContactPoint",
    "telephone": "+18137280702",
    "email": "marizematax@gmail.com",
    "contactType": "customer service",
    "areaServed": "US",
    "availableLanguage": ["English"]
  }
};

export default function SEO({ title, description, path = "/", jsonLd = LOCAL_BUSINESS_LD, type = "website" }) {
  useEffect(() => {
    document.title = title;
    const url = `${SITE_BASE}${path}`;
    upsertMeta("name", "description", description);
    upsertLink("canonical", url);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:type", type);
    upsertMeta("property", "og:site_name", "Marizema Tax Service LLC");
    upsertMeta("property", "og:image", OG_IMAGE);
    upsertMeta("name", "twitter:card", "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", OG_IMAGE);

    let ld = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "page-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, jsonLd, type]);
  return null;
}
